document.addEventListener('DOMContentLoaded', () => {
  (() => {
    // ----- DOM helpers -----
    const drawer = () => document.querySelector('#cart-drawer') || document;
    const SWIPER_SEL = '.upsells__swiper';           // your swiper containers
    const SCROLLBAR_SEL = '.product-upsell__scrollbar';
    const CARD_SEL = '.product-item-container';       // inner card to measure

    // Equalize heights for one Swiper instance
    function equalizeSwiperHeights(swiper) {
      if (!swiper || !swiper.slides?.length) return;

      // reset first
      swiper.slides.forEach((slide) => {
        slide.style.height = '';
        const card = slide.querySelector(CARD_SEL);
        if (card) card.style.height = '';
      });

      // measure
      let max = 0;
      swiper.slides.forEach((slide) => {
        const card = slide.querySelector(CARD_SEL) || slide;
        const h = card.getBoundingClientRect().height;
        if (h > max) max = h;
      });
      if (!max) return;

      // apply
      const h = Math.ceil(max) + 'px';
      swiper.slides.forEach((slide) => {
        slide.style.height = h;
        const card = slide.querySelector(CARD_SEL);
        if (card) card.style.height = '100%';
      });
    }

    // Create/update one swiper for a given element
    function ensureSwiper(el) {
      if (!el) return;

      // If Swiper already attached to this element, just update it
      if (el.swiper && typeof el.swiper.update === 'function') {
        el.swiper.update();
        requestAnimationFrame(() => equalizeSwiperHeights(el.swiper));
        return el.swiper;
      }

      // Try to find the matching scrollbar near this swiper
      const host = el.closest('[data-upsell-block]') || el.parentElement || drawer();
      const scrollbarEl =
        host.querySelector(SCROLLBAR_SEL) ||
        drawer().querySelector(SCROLLBAR_SEL) ||
        SCROLLBAR_SEL; // let Swiper resolve if needed

      // New instance
      const swiper = new Swiper(el, {
        watchOverflow: true,
        slidesPerView: 1.20,
        spaceBetween: 6,
        passiveListeners: true,
        observer: true,
        observeParents: true,

        // make it scroll with wheel / trackpad
        mousewheel: {
          enabled: true,
          releaseOnEdges: true,
        },

        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          hide: false,
        },
      });

      // keep heights in sync with lifecycle changes
      const rerun = () => requestAnimationFrame(() => equalizeSwiperHeights(swiper));
      swiper.on('resize', rerun);
      swiper.on('update', rerun);
      swiper.on('imagesReady', rerun); // if using Swiper's lazy module
      swiper.on('slideChangeTransitionEnd', rerun);

      // when product images load via native lazy-loading
      el.querySelectorAll('img').forEach((img) => {
        img.addEventListener('load', rerun, { passive: true });
      });

      // initial pass
      rerun();

      // also watch size changes to the container
      new ResizeObserver(rerun).observe(el);

      return swiper;
    }

    // Init/update all current swipers in the drawer
    function initAll() {
      drawer().querySelectorAll(SWIPER_SEL).forEach((container) => {
        const sw = ensureSwiper(container);
        if (sw) requestAnimationFrame(() => equalizeSwiperHeights(sw));
      });
    }

    // Destroy swipers for removed nodes to avoid leaks
    function destroyRemoved(nodes) {
      nodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        const list = node.matches?.(SWIPER_SEL)
          ? [node]
          : Array.from(node.querySelectorAll?.(SWIPER_SEL) || []);
        list.forEach((el) => {
          if (el.swiper && typeof el.swiper.destroy === 'function') {
            el.swiper.destroy(true, true);
          }
        });
      });
    }

    // 1) Initial pass
    initAll();

    // 2) Re-run when the AJAX cart updates (same event you use for the calculator)
    document.addEventListener('ajaxCart:updated', () => {
      initAll();
    }, { passive: true });

    // 3) Also watch for lazy injection/re-rendering of the drawer contents
    const mo = new MutationObserver((mutations) => {
      let added = false;
      mutations.forEach((m) => {
        if (m.removedNodes?.length) destroyRemoved(m.removedNodes);
        if (m.addedNodes?.length) added = true;
      });
      if (added) initAll();
    });
    mo.observe(drawer(), { childList: true, subtree: true });

    // 4) Fallback on window resize/orientation
    window.addEventListener('resize', () => {
      drawer().querySelectorAll(SWIPER_SEL).forEach((el) => {
        if (el.swiper) equalizeSwiperHeights(el.swiper);
      });
    }, { passive: true });
  })();
});
